/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const validmap = ['admin', 'editor']
  return validmap
}

/* 合法手机号码 */
export function validatePhone(str) {
  const reg = /^1[3465789]\d{9}$/
  return reg.test(str)
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/* 合法uri */
export function validateURL(textval) {
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return urlregex.test(textval)
}

/* 小写字母 */
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/* 大写字母 */
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/* 大小写字母 */
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * 判断身份证号码
 */
export function validateCardId(code) {
  let result = false
  let msg = ''
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  }
  if (!validateNull(code)) {
    if (code.length === 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = '证件号码格式错误'
      } else if (!city[code.substr(0, 2)]) {
        msg = '地址编码错误'
      } else {
        // 18位身份证需要验证最后一位校验位
        code = code.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]
        // 校验位
        const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x']
        let sum = 0
        let ai = 0
        let wi = 0
        for (let i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        // 身份证最后一位
        const lastCardNum = code[17]
        // 校验码
        const verificationCode = parity[sum % 11] + ''
        if (lastCardNum !== verificationCode) {
          msg = '证件号码校验位错误'
        } else {
          result = true
        }
      }
    } else {
      msg = '证件号码长度不为18位'
    }
  } else {
    msg = '证件号码不能为空'
  }
  console.log(msg)
  return result
}

/**
 * 判断姓名是否正确
 */
export function validateName(name) {
  const regName = /^[\u4e00-\u9fa5]{2,4}$/
  if (!regName.test(name)) return false
  return true
}

/**
 * 判断是否为整数
 */
export function validateNum(num) {
  const regName = /[^\d.]/g
  if (!regName.test(num)) return false
  return true
}

/**
 * 判断是否为小数
 */
export function validateNumord(num) {
  const regName = /[^\d.]/g
  if (!regName.test(num)) return false
  return true
}

export function validateDecimal(num) {
  const regName = /^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/
  // const regName = new RegExp(`^(([1-9]{1}\d*)|(0{1}))(\.\d{0,${dec}})?$`)
  // console.log(regName)
  if (!regName.test(num)) return false
  return true
}

/**
 * 验证表单部分字段
 * @param form
 * @param props
 * @param callback
 */
export function validateFields(form, props, callback) {
  let promise = void 0
  if (typeof callback !== 'function' && window.Promise) {
    promise = new window.Promise(function(resolve, reject) {
      callback = function callback(valid) {
        valid ? resolve(valid) : reject(valid)
      }
    })
  }
  let valid = true
  try {
    props = [].concat(props)
    let count = props.length
    let errors = []
    form.validateField(props, (error) => {
      count--
      if (error) {
        errors = [].concat(errors)
        valid = false
      }
      if (count === 0) {
        if (typeof callback === 'function') {
          callback(valid)
        }
      }
    })
  } catch (error) {
    if (typeof callback === 'function') {
      callback(false)
    }
  }
  if (promise) {
    return promise
  }
}

/**
 * 判断是否为空
 */
export function validateNull(val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') {
      return true
    }
    else{
      return false

    }
  }
  return false
}

/**
 * @param {date} arg
 * @returns {Boolean}
 */
export function isDate(arg) {
  var r = arg.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
  if (r == null) return false
  var d = new Date(r[1], r[3] - 1, r[4])
  return (d.getFullYear() === r[1] && (d.getMonth() + 1) === r[3] && d.getDate() === r[4])
}

// 禁止非数值的输入
export function isNumber(arg) {
  var temp = ''
  for (var i = 0; i < arg.length; i++) {
    if (arg.charCodeAt(i) > 0 && arg.charCodeAt(i) < 255) { temp += arg.charAt(i) }
  }
  return temp
}

//返回两个日期相差的月数
export function MonthsBetw(date1, date2) { //date1和date2是2019-3-12格式
  //用-分成数组
  date1 = date1.split("-");
  date2 = date2.split("-");
  //获取年,月数
  var year1 = parseInt(date1[0]),
      month1 = parseInt(date1[1]),
      year2 = parseInt(date2[0]),
      month2 = parseInt(date2[1]),
      //通过年,月差计算月份差
      months = (year2 - year1) * 12 + (month2 - month1) + 1;
  return months;
}

//计算天数差的函数，通用
export function DateDiff(sDate1, sDate2) { //sDate1和sDate2是2019-3-12格式
  var aDate, oDate1, oDate2, iDays
  aDate = sDate1.split("-")
  oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]) //转换为9-25-2017格式
  aDate = sDate2.split("-")
  oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0])
  iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24) //把相差的毫秒数转换为天数
  return iDays
}